import {html, LitElement} from "lit";
import {customElement, property} from "lit/decorators.js";
import styles from "./SidebarCollapseButton.styles.js";
import Utils from "../../../main/utils/index.js";

@customElement("pn-sidebar-collapse-button")
export class SidebarCollapseButton extends LitElement {
	@property({type: String}) integration: string;

	static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

	static styles = [styles];

	render() {
		return html`
			<button aria-label="Close PowerNotes sidebar">
				<img
					alt="Close PowerNotes sidebar"
					src="${Utils.Common.imgPath("icon-close-arrows.svg")}"
				/>
			</button>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"pn-sidebar-collapse-button": SidebarCollapseButton;
	}
}
